import { Search, X } from "lucide-react";
import { SearchInputProps } from "@/features/shop/types/searchBar.types";

export const SearchInput = ({
  value,
  onChange,
  onFocus,
  placeholder,
  onClear,
  showClearButton = false,
  onSubmit,
}: SearchInputProps) => {
  return (
    <div className="relative z-10 w-full">
      <div className="absolute inset-y-0 left-0 z-10 flex items-center pl-4 pointer-events-none">
        <Search size={16} className="text-gray-400 dark:text-gray-500" />
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
        placeholder={placeholder}
        className="relative z-10 w-full py-4 pl-12 pr-4 text-base font-medium text-gray-900 bg-white border-0 rounded-xl shadow-lg dark:bg-gray-800 dark:text-white placeholder:text-gray-400 dark:placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-white/30 dark:focus:ring-white/20 transition-all duration-200"
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            onSubmit?.(value);
          }
        }}
      />
      {showClearButton && !!value && onClear && (
        <button
          type="button"
          onClick={onClear}
          className="absolute inset-y-0 right-0 z-20 flex items-center pr-4 text-gray-400 transition hover:text-gray-600 dark:hover:text-gray-200"
          aria-label="Effacer la recherche"
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
};
